import React from 'react'
import { Box, Typography, Divider, Link, useMediaQuery } from '@mui/material'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'
import GavelIcon from '@mui/icons-material/Gavel'
import EmailIcon from '@mui/icons-material/Email'

const FooterComponent = () => {
  const isMobile = useMediaQuery('(max-width:600px)')

  const colors = {
    rain: '#324755',
    sage: '#87BCBF',
    snow: '#FFFFFF',
    ice: '#F0F3F4',
    highlight: '#f0c14b',
  }

  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bottom: 0,
        left: 0,
        width: '100%',
        background: `linear-gradient(135deg, ${colors.rain}, #1B1C20)`,
        color: colors.snow,
        padding: isMobile ? '6px 12px' : '10px 20px',
        boxSizing: 'border-box',
      }}
    >
      <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', mb: '6px' }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          fontSize: isMobile ? '0.7rem' : '0.8rem',
        }}
      >
        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, fontSize: isMobile ? '0.65rem' : '0.8rem' }}
        >
          TDIS © 2024. All Rights Reserved.
        </Typography>

        {/* Links Section */}
        <Box sx={{ display: 'flex', gap: isMobile ? '10px' : '15px', alignItems: 'center' }}>
          {[
            { icon: <PrivacyTipIcon fontSize="small" />, text: 'Privacy Policy' },
            { icon: <GavelIcon fontSize="small" />, text: 'Terms of Use' },
            { icon: <EmailIcon fontSize="small" />, text: 'Contact Us' },
          ].map((item, index) => (
            <Link
              key={index}
              href="#"
              underline="none"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                color: colors.snow,
                fontSize: isMobile ? '0.65rem' : '0.8rem',
                '&:hover': { color: colors.highlight },
              }}
            >
              {item.icon} {item.text}
            </Link>
          ))}
        </Box>

        {/* Tagline */}
        <Typography
          variant="body2"
          sx={{
            fontStyle: 'italic',
            fontSize: isMobile ? '0.6rem' : '0.7rem',
          }}
        >
          Empowering Data Intelligence
        </Typography>
      </Box>
    </Box>
  )
}

export default FooterComponent
